var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "authWrapper new-login-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row whiteBG-wrap login-white-wrap"
  }, [_c('div', {
    staticClass: "col-lg-7 col-md-7 no-padding"
  }, [_c('div', {
    staticClass: "login-left-wrap"
  }, [_c('router-link', {
    staticClass: "ms-0 ps-0 login-highlight back-btn-pwd",
    attrs: {
      "to": "/login-password"
    }
  }, [_vm._v("Back")]), _vm._m(0), _c('h4', {
    staticClass: "login-title mb-2"
  }, [_vm._v("Forgot Password")]), _c('div', {
    staticClass: "auth-form pt-1 pb-3"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          on: {
            "submit": function ($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return handleSubmit(_vm.checkUserInfo);
            }
          }
        }, [_c('input-form-text', {
          attrs: {
            "rules": {
              required: true,
              email: true
            },
            "customMessages": `Please enter your email address.`,
            "customEmailMessage": `Please enter a valid email address`,
            "labelFor": "Email",
            "labelName": "Email",
            "inputName": "Email",
            "formGroupClass": "form-group mb-1",
            "placeholder": "Please enter your email",
            "isErrorFlagSet": _vm.userEmailErrorFlag,
            "vmodel": _vm.userEmail
          },
          on: {
            "emitChanges": _vm.resetErrorMsg,
            "update:vmodel": function ($event) {
              _vm.userEmail = $event;
            }
          }
        }), _vm.userEmailErrorFlag ? _c('div', {
          staticClass: "valid-error"
        }, [_vm._v(" " + _vm._s(_vm.errorMsg) + " ")]) : _vm._e(), _c('button', {
          staticClass: "submit-btn mt-3 next-btn",
          attrs: {
            "type": "submit"
          }
        }, [_vm.loginLoader ? _c('b-spinner', {
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" Next ")], 1)], 1)];
      }
    }])
  })], 1)], 1)]), _c('div', {
    staticClass: "col-lg-5 col-md-5 no-padding"
  }, [_c('logincarsoule')], 1)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rep-icon-login"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/member-login.svg"),
      "alt": "image-fluid"
    }
  })]);

}]

export { render, staticRenderFns }